import { memo } from "react";
import { cdnImg } from "../Utils/cdnImage";

const Loader = ({ type }) => {
  return type == "head-coin" ? (
    <img
      id="coinVideo"
      className="ng-tns-c4049933992-86 ng-star-inserted heartBeat"
      src={cdnImg("/assets/Other/logo-dark.png")}
    />
  ) : (
    <>
      <div className="loading-mask ng-tns-c978432208-1 ng-trigger ng-trigger-fastFadeInOut ng-star-inserted" />
      <div className="loader-box ng-tns-c978432208-1 ng-star-inserted">
        <div className="movie-box ng-tns-c978432208-1 ng-star-inserted">
          <img
            style={{ width: "100%" }}
            id="coinVideo"
            className="ng-tns-c4049933992-86 ng-star-inserted"
            src={cdnImg("/assets/Other/logo-dark.png")}
          />
        </div>
      </div>{" "}
    </>
  );
};

export default memo(Loader);
